import {useContext} from "react";
import Config from "../types/Config";
import ConfigContext from "../contexts/ConfigContext";

export default function useConfig(): Config {
  return useContext(ConfigContext);
}
